import React from "react";
import { useSelector } from "react-redux";
import CustomTable from "../../../blueplanitUtils/CustomTabels";
import PersonalInformationModelPopup from "../../../components/modelpopup/PersonalInformationModelPopup";
import AddNoteBox from "./addNote";
import { ReportingManagerPopUp } from "../../../components/ProfileEditpopUp/ReportingManagerPopUp";
import { ReportModelpopUp } from "../../../components/ProfileEditpopUp/ReportesModelPopUp";

const ReportingTable = () => {
  const Reports = useSelector((state) => state.employee.managersData);
  const reportingDirect = useSelector((state) => state.employee.reportsDatas);

  const columns = ["Name",  "Designation", "Department"];
  const reportingManagerLabels = [
    "reportingManagerName",
    "reportingManagerDesignation",
    "reportingManagerDepartment",
  ];
  const directReportLabels = [
    "DirectReportName",
    "DirectReportDesignation",
    "DirectReportDepartment",
    "DirectReportType"
   
  ];
  const updatedColumns = [...columns, 'Type'];

  return (
    <div className="col">
      <CustomTable
        title="Reporting Manager"
        data={Reports}
        columns={columns}
        dataLabel={reportingManagerLabels}
        Id="reporting_manager"
      />

      <CustomTable
        title="Direct Reports"
        data={reportingDirect}
        columns={updatedColumns}
        dataLabel={directReportLabels}
        Id="direct_reports"
      />

      <ReportingManagerPopUp />
      <ReportModelpopUp />
      <PersonalInformationModelPopup name={"teamNote"} />
      <AddNoteBox name={"teamNote"} />
    </div>
  );
};

export default ReportingTable;
